import { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { InputSelect } from "../../components/formComponents/inputSelect";
import { DataContext } from "../../contextData/contextData";
import ErrorInput from "../../components/ui/ErrorInput";
import { useCambioUnidad } from "./useCambioDeUnidad";

export const CambioDeUnidad = (props) => {
  const { formik, tipo } = props;
  const { setTemporis, arrTemporis, arrPlanHorario } = useCambioUnidad();
  const { uno } = useContext(DataContext);

CambioDeUnidad.propTypes = {
  formik: PropTypes.object.isRequired,
  tipo: PropTypes.number,
};

  useEffect(() => {
    setTemporis(formik.values.cod_sap_nuevo_cargo);
  }, [formik.values.cod_sap_nuevo_cargo]);

  useEffect(() => {
    if (formik.values.fecha_inicio_cambio) {
      formik.setTouched({ ...formik.touched, fecha_inicio_cambio: true });
    }
    setTemporis(uno);
  }, [formik.values.fecha_inicio_cambio]);

  useEffect(() => {
    if (formik.values.nuevo_plan_horario && !String(formik.values.nuevo_plan_horario).includes("|")) {
      const valStr = String(formik.values.nuevo_plan_horario).trim();
      const unPlan = arrPlanHorario.find(
        (el) => String(el.id).trim() === valStr || String(el.Planhorariocodigoerp).trim() === valStr
      );

      if (unPlan) {
        formik.setFieldValue("nuevo_plan_horario", `${unPlan.Planhorariocodigoerp}|${unPlan.Planhorarionombre}`);
      }
    }
  }, [formik.values.nuevo_plan_horario, arrPlanHorario]);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between">
          <label htmlFor="nueva_unidad_organizativa">Unidad organizativa - cargo (Temporis) *</label>
          {formik.errors.nueva_unidad_organizativa !== undefined && formik.touched.nueva_unidad_organizativa !== undefined && (
            <ErrorInput touched={formik.touched.nueva_unidad_organizativa} error={formik.errors.nueva_unidad_organizativa} />
          )}
        </div>

        <InputSelect
          subKey="a"  
          disabled={!formik.values.cod_sap_nuevo_cargo && tipo === 1}
          arr={arrTemporis}
          id="nueva_unidad_organizativa"
          llave_texto="label"
          llave_valor="value"
          formik={formik}
        />
      </div>
      <div>
        <div className="d-flex justify-content-between">
          <label htmlFor="nuevo_plan_horario">Plan horario *</label>
          {formik.errors.nuevo_plan_horario !== undefined && formik.touched.nuevo_plan_horario !== undefined && (
            <ErrorInput touched={formik.touched.nuevo_plan_horario} error={formik.errors.nuevo_plan_horario} />
          )}
        </div>
        <InputSelect
          subKey="b"
          disabled={!formik.values.cod_sap_nuevo_cargo && tipo === 1}
          id="nuevo_plan_horario"
          arr={arrPlanHorario}
          llave_texto="Planhorarionombre"
          llave_valor="id"
          formik={formik}
        />
      </div>
    </>
  );
};
